import React from 'react';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';

import { TrackerProvider } from '@dpdgroupuk/react-event-tracker';
import { Provider as DialogProvider } from '@dpdgroupuk/fmx-ui/components/Dialog';
import OverlayProvider from '@dpdgroupuk/fmx-ui/components/Overlay';
import { TouchStartHandler } from '@dpdgroupuk/fmx-ui/hocs';
import { EnvProvider } from '@dpdgroupuk/fmx-ui/env';
import { SnackbarProvider } from 'notistack';
import { Provider as ChatProvider } from '@dpdgroupuk/cc-chat-fe';
import '@dpdgroupuk/cc-chat-fe/dist/components/ChatBotApp.css';

// must be exactly in that order: firebase, analytics
import { initializeRemoteConfig } from './utils/firebase';
import tracker from './utils/analytics';
import Router from './Router';
import store from './store';
import ErrorBoundary from './components/ErrorBoundary';
import { ConfigProvider } from './components/RemoteConfig';
import GlobalCSS from './components/theme';
import { API_HOST, ENTITY_PREFIX } from './constants/app';
import ThemeAndEventProvider from './ThemeAndEventProvider';
import { MetaRobotsNoIndex } from './utils/metaRobots';
import { CHAT_CONFIG } from './constants/chat';

const App = () => (
  <>
    <MetaRobotsNoIndex />
    <Provider store={store}>
      <EnvProvider value={{ API_HOST, ENTITY_PREFIX }}>
        <ConfigProvider remoteConfig={initializeRemoteConfig()}>
          <TrackerProvider tracker={tracker}>
            <ThemeAndEventProvider>
              <OverlayProvider position="fixed">
                <TouchStartHandler>
                  <DialogProvider>
                    <GlobalCSS />
                    <CssBaseline />
                    <ErrorBoundary>
                      <ChatProvider chatConfig={CHAT_CONFIG}>
                        <SnackbarProvider
                          maxSnack={3}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                        >
                          <Router />
                        </SnackbarProvider>
                      </ChatProvider>
                    </ErrorBoundary>
                  </DialogProvider>
                </TouchStartHandler>
              </OverlayProvider>
            </ThemeAndEventProvider>
          </TrackerProvider>
        </ConfigProvider>
      </EnvProvider>
    </Provider>
  </>
);

export default App;
